import {
  Button,
  FormControl,
  InputLabel,
  OutlinedInput,
  TextField,
  InputAdornment,
  Link,
  Alert,
  IconButton,
  Box,
} from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { AppProvider } from "@toolpad/core/AppProvider";
import { useTheme } from "@mui/material/styles";
import { supabase } from "../supabase";
import { useNavigate } from "react-router-dom";
import { useState } from 'react';

function CustomEmailField() {
  return (
    <TextField
      id="email-field"
      label="Email"
      name="email"
      type="email"
      size="small"
      required
      fullWidth
      variant="outlined"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <AccountCircle fontSize="inherit" />
          </InputAdornment>
        ),
      }}
    />
  );
}

function CustomPasswordField() {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  return (
    <FormControl sx={{ my: 2 }} fullWidth variant="outlined">
      <InputLabel size="small" htmlFor="password-field">
        Password
      </InputLabel>
      <OutlinedInput
        id="password-field"
        type={showPassword ? "text" : "password"}
        name="password"
        size="small"
        required
        endAdornment={
          <InputAdornment position="end">
            <IconButton onClick={handleClickShowPassword} edge="end" size="small">
              {showPassword ? <VisibilityOff fontSize="inherit" /> : <Visibility fontSize="inherit" />}
            </IconButton>
          </InputAdornment>
        }
        label="Password"
      />
    </FormControl>
  );
}

function CustomConfirmPasswordField() {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  return (
    <FormControl sx={{ my: 2 }} fullWidth variant="outlined">
      <InputLabel size="small" htmlFor="confirm-password-field">
        Confirm Password
      </InputLabel>
      <OutlinedInput
        id="confirm-password-field"
        type={showPassword ? "text" : "password"}
        name="confirmPassword"
        size="small"
        required
        endAdornment={
          <InputAdornment position="end">
            <IconButton onClick={handleClickShowPassword} edge="end" size="small">
              {showPassword ? <VisibilityOff fontSize="inherit" /> : <Visibility fontSize="inherit" />}
            </IconButton>
          </InputAdornment>
        }
        label="Confirm Password"
      />
    </FormControl>
  );
}

function CustomSignUpButton() {
  return (
    <Button type="submit" variant="contained" color="primary" size="medium" disableElevation fullWidth sx={{ my: 2 }}>
      Sign Up
    </Button>
  );
}

function LoginLink() {
  const navigate = useNavigate();
  return (
    <Link component="button" variant="body2" onClick={() => navigate("/")}> 
      Already have an account? Log in
    </Link>
  );
}

function Title() {
  return <h2 style={{ marginBottom: 8 }}>Sign Up</h2>;
}

function Subtitle() {
  return (
    <Alert sx={{ mb: 2, px: 1, py: 0.5 }} severity="info">
      Create a new account for Maniko Influencer Tool
    </Alert>
  );
}

export default function SlotsSignUp() {
  const theme = useTheme();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  const handleSignUp = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const email = formData.get("email");
    const password = formData.get("password");
    const confirmPassword = formData.get("confirmPassword");

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setError("");
    const { error } = await supabase.auth.signUp({ email, password });

    if (error) {
      setError(error.message);
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <AppProvider theme={theme}>
      <Box sx={{ maxWidth: 400, mx: "auto", mt: 4 }}>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <form onSubmit={handleSignUp}>
          <Title />
          <Subtitle />
          <CustomEmailField />
          <CustomPasswordField />
          <CustomConfirmPasswordField />
          <CustomSignUpButton />
          <Box sx={{ mt: 2, textAlign: "center" }}>
            <LoginLink />
          </Box>
        </form>
      </Box>
    </AppProvider>
  );
}